import { render, staticRenderFns } from "./NewsBanner.vue?vue&type=template&id=1202b063&scoped=true"
import script from "./NewsBanner.vue?vue&type=script&lang=js"
export * from "./NewsBanner.vue?vue&type=script&lang=js"
import style0 from "./NewsBanner.vue?vue&type=style&index=0&id=1202b063&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1202b063",
  null
  
)

export default component.exports